import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ProductUsedIn } from '../ProductUsedIn'
import type { Product } from '../Product'
import type { ProjectionFields } from '../../repository/types'

@InputType()
export class GetProductUsedInArgs extends ActionArgs {
  // The lookup matches any of these ids in one query, so an ancestor walk
  // advances a whole frontier per round trip instead of one product per round trip.
  @Field(() => [ID])
  productIds: string[]

  // Server-only, never exposed in the schema (same shape as ActionArgs.user):
  // callers that only need parent ids pass a narrow projection so the walk
  // transfers BOM references instead of full product documents.
  projection?: ProjectionFields<Product>
}

export interface IGetProductUsedIn extends IAction<ProductUsedIn[], GetProductUsedInArgs> {}
